import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import rootReducer from "./Service/Reducers/rootReducer";
import { legacy_createStore, applyMiddleware } from "@reduxjs/toolkit";

const customMiddleWare = (store) => (next) => (action) => {
  if (action.type === "token_not_valid") {
    store.dispatch({ type: "Set_Branch_first", data: null });
    store.dispatch({ type: "Remove_User" });
  } else {
    next(action);
  }
};

const store = legacy_createStore(
  rootReducer,
  applyMiddleware(customMiddleWare)
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
